import { Scope } from '../../api'
import { getAllEnumOptions } from '../enum'

export const getAllScopes = () => getAllEnumOptions(Scope)

export const getScopeLabel = (key?: Scope) => {
  if (key === null || typeof key === 'undefined') return ''

  return Scope[key]
}
